import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-85106692"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "signsure-detail-wrapper" }
const _hoisted_2 = { style: {"padding":"24px"} }
const _hoisted_3 = { class: "apply-info border-bottom" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"600","color":"#333333","margin-bottom":"20px","margin-left":"10px","display":"inline-block"} }, "预备名称", -1))
const _hoisted_5 = { style: {"padding-left":"10px","border-bottom":"1px solid #eee"} }
const _hoisted_6 = { style: {"padding-left":"10px","padding-bottom":"24px","border-bottom":"1px solid #eee"} }
const _hoisted_7 = { class: "flow-box border-bottom" }
const _hoisted_8 = { class: "modal-remark-label" }
const _hoisted_9 = {
  key: 0,
  class: "xingxing"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "备注", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "modal-uploader-label" }, "附件上传", -1))
const _hoisted_12 = { class: "upload-wrapper" }
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "上传文件", -1))

import BusinessDetail from "@/views/Change/Detail/BusinessDetail.vue";
import AddressDetail from "@/views/Change/Detail/AddressDetail.vue";
import { ref, reactive, createVNode, onMounted, watchEffect } from "vue";
import { message, Modal } from "ant-design-vue";

import HeadTitle from "@/components/HeadTitle.vue";
import Approval from "@/components/Approval.vue";
import ApplyInfoCard from "@/components/ApplyInfoCard.vue";
import ButtonGroup from "@/components/ButtonGroup.vue";
import Borrow from "./Detail/Borrow.vue";
import Financial from "./Detail/Financial.vue";
import Person from "./Detail/Person.vue";
import FilingsInfo from "./Detail/FilingsInfo.vue";
import Depro from "./Detail/Depro.vue";
import Transfer from "../Process/EmployeeTransferApply/Detail/Transfer.vue";
import Step1 from "./Detail/Step1.vue";
import Step2 from "./Detail/Step2.vue";
import Step3 from "./Detail/Step3.vue";
import HouseRent from "./Detail/HouseRent.vue";
import OpenMatter from "./Detail/OpenMatter.vue";
import Detail from "../Process/Opening/detail.vue";
import Site from "./Detail/Site.vue";
import Tax from "./Detail/Tax.vue";
import Register from "@/components/RegisterInfo.vue";
import BankOpenFilings from "../Process/Bank/Detail/Register.vue";
import Bank from "./Detail/Bank.vue";
import CheckCompany from "@/components/CheckCompany.vue";
import FormalOpen from "@/components/FormalOpen.vue";
// 工商变更详情--新增
import TaxRelocate from "./Detail/TaxRelocate.vue";
import InformationSeal from "./Detail/InformationSeal.vue";
import DecorationAgreement from "./Detail/DecorationAgreement.vue";
import SealsCertificatesEngraving from "./Detail/SealsCertificatesEngraving.vue";
import RenContract from "./Detail/RenContract.vue";
import AccountApply from "./Detail/AccountApply.vue";
import Kaihu from "./Detail/Kaihu.vue";
import Shuizhong from "./Detail/Shuizhong.vue";
import { GetCurrentMyPageList } from "@/api/index";
import type { UploadProps, UploadChangeParam } from "ant-design-vue";
import axios from "axios";
import { PlusOutlined, LoadingOutlined } from "@ant-design/icons-vue";
import { useStore } from "vuex";
import { setReadStatus } from "@/api/approve";

import { setDockingCashierName, approve, dockinglist } from "@/api/openapply";
import {
  businessApproveApi,
  companyFlowApproveApi,
} from "@/api/businessChange";
import {
  CaretDownOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons-vue";
import { useRoute, useRouter } from "vue-router";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const actionButtons = ref<string[]>([]);
const { type, id, traceId } = route.query;
const showChangeDocking = ref<boolean>(false);
const rejectedVisible = ref<boolean>(false);
const U8CAccount = ref<string>("");
const rejectResume = ref<string>("");
const dialogType = ref<string>("");
const disableClose = ref<boolean>(true);
const uploadTypeValue = ref<string>("");
const fileList = ref([]);
const PageFiles = ref<
  {
    FileName: string;
    FileUrl: string;
  }[]
>([]);
const WorkFlowId = ref<number>(0);
const refresh = ref<boolean>(false);
const BranchCompanyFlowId = ref<string>("");
const allDocking = ref<
  {
    value: string;
    label: string;
  }[]
>([]);
const allAccounting = ref<
  {
    value: string;
    label: string;
  }[]
>([]);
const data = reactive({
  ApplicationInfo: {
    ApplicationTime: "",
    CompanyName: "",
    DepartmentName: "",
    IsCreate: 0,
    LeaderName: "",
    PhotoUrl: "",
    PositionName: "",
    PostType: null,
    StaffId: 0,
    StaffName: "",
  },
  ApplicationTime: "",
});
const setButtonStatus = ({
  id,
  buttons,
  flowId,
  ApplicationInfo,
  ApplicationTime,
}) => {
  var arr = [];
  for (let i in buttons) {
    arr.push(buttons[i]);
  }
  let actionButtonsList = ["90", ...arr];
  actionButtons.value = actionButtonsList.filter(
    (item) =>
      item == 90 || item == 103 || item == 104 || item == 105 || item == 106
  );
  WorkFlowId.value = flowId;
  BranchCompanyFlowId.value = id;

  data.ApplicationInfo = ApplicationInfo;
  data.ApplicationTime = ApplicationTime;
};
const form = reactive({
  DockingCashierName: "",
  DockingAccountingName: "",
  DockingCashier: "",
  DockingAccounting: "",
});
const update = ref<boolean>(false);
const tableFlag = computed(() => route.query.tableFlag);
const loading = ref<boolean>(false);
const headers = {
  Authorization: sessionStorage.getItem("token"),
};
const handleClick = (buttonType: string | number) => {
  if (buttonType == "103") {
    rejectedVisible.value = true;
    dialogType.value = "103";
    // Modal.confirm({
    //   content: "您确认要通过审核吗？",
    //   icon: createVNode(ExclamationCircleOutlined),
    //   onOk() {
    //     pass();
    //   },
    //   style: {
    //     top: "30%",
    //   },
    //   cancelText: "取消",
    //   onCancel() {
    //     Modal.destroyAll();
    //   },
    // });
  } else if (buttonType == "105") {
    //需要设置财务出纳和会计
    showChangeDocking.value = true;
  } else if (buttonType == "104") {
    dialogType.value = "104";
    rejectedVisible.value = true;
  } else if (buttonType == "106") {
    //开业申请通过 如果有权限 显示弹窗 todo:权限设置
    showChangeDocking.value = true;
  }
};
watchEffect(() => {
  const { tableFlag, TOCCId, id } = route.query;
  // 来源抄送我的需要调用此接口
  if (
    tableFlag &&
    tableFlag === "isFromCopyTable" &&
    TOCCId &&
    Number(TOCCId) > 0
  ) {
    id && setReadStatus({ id: Number(TOCCId) });
  }
});
onMounted(() => {
  getDockingList();
});

const filterOption = (input: string, option: any) => {
  return option.label.indexOf(input) >= 0;
};

const getDockingList = async () => {
  //出纳
  const { DockingCashier = [], DockingAccounting = [] } = await dockinglist();

  DockingCashier.forEach((r: any) => {
    allDocking.value.push({
      value: r.Val,
      label: r.Key,
    });
  });
  DockingAccounting.forEach((r: any) => {
    allAccounting.value.push({
      value: r.Val,
      label: r.Key,
    });
  });
};

const setDockingName = (dock: {
  DockingCashierName?: string;
  DockingAccountingName?: string;
  DockingCashier?: string;
  DockingAccounting?: string;
}) => {
  form.DockingCashier = dock.DockingCashier || "";
  form.DockingAccounting = dock.DockingAccounting || "";
  // update.value = !update.value;
  refresh.value = !refresh.value;
};

const changeDocking = async () => {
  const { Success } = await setDockingCashierName({
    Id: BranchCompanyFlowId.value,
    DockingCashierName: form.DockingCashierName,
    DockingAccountingName: form.DockingAccountingName,
    DockingCashier: form.DockingCashier,
    DockingAccounting: form.DockingAccounting,
  });
  if (Success) {
    update.value = !update.value;
    refresh.value = !refresh.value;
    message.success("设置成功");
  } else {
    refresh.value = !refresh.value;
    message.success("设置失败");
  }
  showChangeDocking.value = false;
};

const pass = async (Status: number) => {
  if (type == 13 && dialogType.value == "103" && U8CAccount.value == "") {
    return message.warning("请填写U8C帐号");
  }
  var method = approve;
  let param = {
    CustomerFields: { U8CAccount: U8CAccount.value },
    Description: rejectResume.value,
    Status: Status, //1:通过 2: 驳回
    PageFiles: PageFiles.value,
  };
  if (type == 9) {
    method = businessApproveApi;
  } else if (type == 10 || type == 11 || type == 12) {
    method = companyFlowApproveApi;
  }

  if (type == 9) {
    param.id = id;
  } else {
    param.WorkflowId = WorkFlowId.value;
  }
  const { Success } = await method(param);
  if (Success) {
    refresh.value = !refresh.value;
    update.value = !update.value;
    message.success(`${Status == 1 ? "提交成功" : "已驳回"}`);
    rejectedVisible.value = false;
    getList();
  } else {
    refresh.value = !refresh.value;
    message.success(`${Status == 1 ? "提交失败" : "驳回失败"}`);
  }
};

//添加驳回理由
const setRejectResume = async () => {
  // 判断是驳回还是通过
  if (dialogType.value == "103") {
    // 通过
    pass(1);
  } else if (dialogType.value == "104") {
    // 驳回
    if (!rejectResume.value) {
      message.error("请填写备注");
      return;
    }
    pass(2);
  }
};
// 获取文件类型
const getFileType = (imgObj: string) => {
  // 1: 图片  2： paf  3： word  4: txt  5 zip 6 excel 7 ppt 8 other
  let val = 1;
  const SrcArr = imgObj.split(".");
  if (SrcArr.includes("pdf") || SrcArr.includes("PDF")) {
    val = 2;
  } else if (SrcArr.includes("doc") || SrcArr.includes("docx")) {
    val = 3;
  } else if (SrcArr.includes("txt")) {
    val = 4;
  } else if (SrcArr.includes("zip") || SrcArr.includes("rar")) {
    val = 5;
  } else if (
    SrcArr.includes("excel") ||
    SrcArr.includes("xlsx") ||
    SrcArr.includes("xls")
  ) {
    val = 6;
  } else if (SrcArr.includes("ppt")) {
    val = 7;
  } else if (
    SrcArr.includes("jpg") ||
    SrcArr.includes("png") ||
    SrcArr.includes("jpeg") ||
    SrcArr.includes("gif") ||
    SrcArr.includes("JPG") ||
    SrcArr.includes("PNG") ||
    SrcArr.includes("JPEG") ||
    SrcArr.includes("GIF")
  ) {
    val = 1;
  } else {
    val = 8;
  }
  return val;
};

const beforeUpload = (file: UploadProps["fileList"][number]) => {
  //todo: excel表格兼容
  const type = getFileType(file.name);
  const isPermit =
    type == 1 || type == 2 || type == 3 || type == 5 || type == 6 || type == 8;
  // ".pdf,image/png, image/jpeg, image/gif, image/jpg, .zip,.doc,.docx,.xls";
  if (!isPermit) {
    message.error("支持上传图片、pdf、Excel、word、.xls、压缩包!");
  }
  const isLt20M = file.size / 1024 / 1024 < 45;
  if (!isLt20M) {
    message.error("上传不得超过45M");
  }
  return isLt20M && isPermit;
};
const handleChange = (info: UploadChangeParam) => {
  if (info.file.status === "uploading") {
    loading.value = true;
    return;
  }
  if (info.file.status === "done") {
    loading.value = false;
    const { Data = [], Success, Message } = info.file.response;
    if (Success) {
      uploadTypeValue.value = Data[0].Url;
      PageFiles.value.push({
        FileName: Data[0].FileName,
        FileUrl: Data[0].Url,
      });
      loading.value = false;
      disableClose.value = false;
      message.success("上传成功");
    } else {
      disableClose.value = true;
      message.error(Message || "上传失败");
    }
  }
  if (info.file.status === "error") {
    loading.value = false;
    disableClose.value = true;
    message.error("上传失败");
  }
};
const resetField = () => {
  loading.value = false;
  fileList.value = [];
  uploadTypeValue.value = "";
  PageFiles.value = [];
};
const hiddenReject = () => {
  rejectedVisible.value = false;
  U8CAccount.value = "";
  rejectResume.value = "";
  uploadTypeValue.value = "";
  PageFiles.value = [];
};
const getList = async () => {
  const { Success, Data } = await GetCurrentMyPageList();

  if (Success) {
    store.commit("setWaitList", Data.ApproveCount);
    store.commit("setToList", Data.ToCCCount);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_BreadCrumb = _resolveComponent("BreadCrumb")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BreadCrumb, {
      meteItems: 
      _unref(tableFlag) == 'isFromApplyTable'
        ? ['申请列表', '申请详情']
        : _unref(tableFlag) == 'isFromApproveTable'
        ? ['已审批', '审批详情']
        : _unref(tableFlag) == 'isFromMyCreatTable'
        ? ['我发起的', '审批详情']
        : _unref(tableFlag) == 'isFromCopyTable'
        ? ['抄送我的', '审批详情']
        : ['待审批', '审批详情']
    
    }, null, 8, ["meteItems"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(HeadTitle, { title: "申请人信息" }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(ApplyInfoCard, {
            ApplicationInfo: _unref(data).ApplicationInfo,
            ApplicationTime: _unref(data).ApplicationTime
          }, null, 8, ["ApplicationInfo", "ApplicationTime"])
        ]),
        (_unref(type) == '202' || _unref(type) == '203')
          ? (_openBlock(), _createBlock(Borrow, {
              key: 0,
              "folw-id": _unref(id),
              onChangeStatus: setButtonStatus,
              update: update.value
            }, null, 8, ["folw-id", "update"]))
          : _createCommentVNode("", true),
        (_unref(type) == '201')
          ? (_openBlock(), _createBlock(Financial, {
              key: 1,
              "folw-id": _unref(id),
              onChangeStatus: setButtonStatus,
              update: update.value
            }, null, 8, ["folw-id", "update"]))
          : _createCommentVNode("", true),
        (_unref(type) == '504')
          ? (_openBlock(), _createBlock(FilingsInfo, {
              key: 2,
              "folw-id": _unref(id),
              update: update.value,
              onChangeStatus: setButtonStatus,
              style: {"margin-left":"10px"}
            }, null, 8, ["folw-id", "update"]))
          : _createCommentVNode("", true),
        (_unref(type) == '501')
          ? (_openBlock(), _createBlock(Step1, {
              key: 3,
              "folw-id": _unref(id),
              onChangeStatus: setButtonStatus,
              update: update.value,
              style: {"margin-left":"10px"}
            }, null, 8, ["folw-id", "update"]))
          : _createCommentVNode("", true),
        (_unref(type) == '502')
          ? (_openBlock(), _createBlock(Step2, {
              key: 4,
              "folw-id": _unref(id),
              update: update.value,
              onChangeStatus: setButtonStatus,
              style: {"margin-left":"10px"}
            }, null, 8, ["folw-id", "update"]))
          : _createCommentVNode("", true),
        (_unref(type) == '503')
          ? (_openBlock(), _createBlock(Step3, {
              key: 5,
              "folw-id": _unref(id),
              update: update.value,
              onChangeStatus: setButtonStatus
            }, null, 8, ["folw-id", "update"]))
          : _createCommentVNode("", true),
        (_unref(type) == '601')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
              _createVNode(HeadTitle, {
                title: "开户银行申请",
                style: {"margin-top":"24px","margin-bottom":"20px"}
              }),
              _createVNode(Bank, {
                "folw-id": _unref(id),
                update: update.value,
                onChangeStatus: setButtonStatus,
                style: {"padding-left":"10px"}
              }, null, 8, ["folw-id", "update"])
            ], 64))
          : _createCommentVNode("", true),
        (_unref(type) == '602')
          ? (_openBlock(), _createBlock(Tax, {
              key: 7,
              "folw-id": _unref(id),
              update: update.value,
              onChangeStatus: setButtonStatus,
              style: {"padding-left":"10px"}
            }, null, 8, ["folw-id", "update"]))
          : _createCommentVNode("", true),
        (_unref(type) == '603')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
              _createVNode(HeadTitle, {
                title: "银行开户备案申请",
                style: {"margin-top":"24px","margin-bottom":"20px"}
              }),
              _createVNode(BankOpenFilings, {
                "folw-id": _unref(id),
                update: update.value,
                onChangeStatus: setButtonStatus
              }, null, 8, ["folw-id", "update"])
            ], 64))
          : _createCommentVNode("", true),
        (_unref(type) == '701')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
              _createVNode(HeadTitle, {
                title: "员工调动申请",
                style: {"margin-top":"24px"}
              }),
              _createVNode(Transfer, {
                "folw-id": _unref(id),
                update: update.value,
                onChangeStatus: setButtonStatus,
                style: {"padding-left":"10px"}
              }, null, 8, ["folw-id", "update"])
            ], 64))
          : _createCommentVNode("", true),
        (_unref(type) == '702')
          ? (_openBlock(), _createBlock(Person, {
              key: 10,
              "folw-id": _unref(id),
              update: update.value,
              onChangeStatus: setButtonStatus
            }, null, 8, ["folw-id", "update"]))
          : _createCommentVNode("", true),
        (_unref(type) == '1')
          ? (_openBlock(), _createBlock(OpenMatter, {
              key: 11,
              "folw-id": _unref(id),
              update: update.value,
              onChangeStatus: setButtonStatus,
              onChangeDock: setDockingName,
              style: {"padding-left":"10px"}
            }, null, 8, ["folw-id", "update"]))
          : _createCommentVNode("", true),
        (_unref(type) == '8')
          ? (_openBlock(), _createBlock(FormalOpen, {
              key: 12,
              "folw-id": _unref(id),
              update: update.value,
              onChangeStatus: setButtonStatus,
              style: {"padding-left":"10px"}
            }, null, 8, ["folw-id", "update"]))
          : _createCommentVNode("", true),
        (_unref(type) == '401')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 13 }, [
              _createVNode(HeadTitle, {
                title: "核名申请",
                style: {"margin-top":"24px","margin-bottom":"20px"}
              }),
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createVNode(CheckCompany, {
                  "folw-id": _unref(id),
                  update: update.value,
                  onChangeStatus: setButtonStatus
                }, null, 8, ["folw-id", "update"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_unref(type) == '402')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 14 }, [
              _createVNode(HeadTitle, {
                title: "开设公司账号申请",
                style: {"margin-top":"24px","margin-bottom":"20px"}
              }),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(Register, {
                  "folw-id": _unref(id),
                  update: update.value,
                  onChangeStatus: setButtonStatus
                }, null, 8, ["folw-id", "update"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_unref(type) == '301')
          ? (_openBlock(), _createBlock(Site, {
              key: 15,
              "folw-id": _unref(id),
              update: update.value,
              onChangeStatus: setButtonStatus,
              style: {"padding-left":"10px"}
            }, null, 8, ["folw-id", "update"]))
          : _createCommentVNode("", true),
        (_unref(type) == '302')
          ? (_openBlock(), _createBlock(HouseRent, {
              key: 16,
              "folw-id": _unref(id),
              update: update.value,
              onChangeStatus: setButtonStatus,
              style: {"padding-left":"10px"}
            }, null, 8, ["folw-id", "update"]))
          : _createCommentVNode("", true),
        (_unref(type) == '303')
          ? (_openBlock(), _createBlock(Depro, {
              key: 17,
              "folw-id": _unref(id),
              update: update.value,
              onChangeStatus: setButtonStatus
            }, null, 8, ["folw-id", "update"]))
          : _createCommentVNode("", true),
        (_unref(type) == '1201')
          ? (_openBlock(), _createBlock(InformationSeal, {
              key: 18,
              "folw-id": _unref(id),
              id: _unref(id),
              traceId: _unref(traceId),
              update: update.value,
              onChangeStatus: setButtonStatus
            }, null, 8, ["folw-id", "id", "traceId", "update"]))
          : _createCommentVNode("", true),
        (_unref(type) == '1202')
          ? (_openBlock(), _createBlock(TaxRelocate, {
              key: 19,
              "folw-id": _unref(id),
              traceId: _unref(traceId),
              id: _unref(id),
              update: update.value,
              onChangeStatus: setButtonStatus,
              style: {"padding-left":"10px"}
            }, null, 8, ["folw-id", "traceId", "id", "update"]))
          : _createCommentVNode("", true),
        (_unref(type) == '1203')
          ? (_openBlock(), _createBlock(SealsCertificatesEngraving, {
              key: 20,
              "folw-id": _unref(id),
              update: update.value,
              id: _unref(id),
              onChangeStatus: setButtonStatus,
              traceId: _unref(traceId)
            }, null, 8, ["folw-id", "update", "id", "traceId"]))
          : _createCommentVNode("", true),
        (_unref(type) == '1101')
          ? (_openBlock(), _createBlock(RenContract, {
              key: 21,
              "folw-id": _unref(id),
              update: update.value,
              id: _unref(id),
              traceId: _unref(traceId),
              onChangeStatus: setButtonStatus,
              style: {"padding-left":"10px"}
            }, null, 8, ["folw-id", "update", "id", "traceId"]))
          : _createCommentVNode("", true),
        (_unref(type) == '1102')
          ? (_openBlock(), _createBlock(DecorationAgreement, {
              key: 22,
              "folw-id": _unref(id),
              id: _unref(id),
              traceId: _unref(traceId),
              update: update.value,
              onChangeStatus: setButtonStatus,
              style: {"padding-left":"10px"}
            }, null, 8, ["folw-id", "id", "traceId", "update"]))
          : _createCommentVNode("", true),
        (_unref(type) == '9')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 23 }, [
              _createVNode(HeadTitle, {
                title: "工商变更申请",
                style: {"margin-top":"24px","margin-bottom":"20px"}
              }),
              _createVNode(BusinessDetail, {
                update: update.value,
                id: _unref(id),
                onChangeStatus: setButtonStatus
              }, null, 8, ["update", "id"])
            ], 64))
          : _createCommentVNode("", true),
        (_unref(type) == '10')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 24 }, [
              _createVNode(HeadTitle, {
                title: "地址变更申请",
                style: {"margin-top":"24px","margin-bottom":"20px"}
              }),
              _createVNode(AddressDetail, {
                update: update.value,
                BranchCompanyFlowId: _unref(id),
                onChangeStatus: setButtonStatus
              }, null, 8, ["update", "BranchCompanyFlowId"])
            ], 64))
          : _createCommentVNode("", true),
        (_unref(type) == '13')
          ? (_openBlock(), _createBlock(AccountApply, {
              key: 25,
              update: update.value,
              folwId: _unref(id),
              onChangeStatus: setButtonStatus
            }, null, 8, ["update", "folwId"]))
          : _createCommentVNode("", true),
        (_unref(type) == '604')
          ? (_openBlock(), _createBlock(Kaihu, {
              key: 26,
              "folw-id": _unref(id),
              update: update.value,
              onChangeStatus: setButtonStatus
            }, null, 8, ["folw-id", "update"]))
          : _createCommentVNode("", true),
        (_unref(type) == '605')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 27 }, [
              _createVNode(HeadTitle, {
                title: "税种申请",
                style: {"margin-top":"24px","margin-bottom":"20px"}
              }),
              _createVNode(Shuizhong, {
                "folw-id": _unref(id),
                update: update.value,
                onChangeStatus: setButtonStatus,
                style: {"padding-left":"10px"}
              }, null, 8, ["folw-id", "update"])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(HeadTitle, {
            title: '审批流程',
            class: "flow-box-headtitle"
          }),
          _createVNode(Approval, {
            refresh: refresh.value,
            id: WorkFlowId.value,
            isLoadHistory: 0,
            BranchCompanyFlowId: _unref(id)
          }, null, 8, ["refresh", "id", "BranchCompanyFlowId"])
        ])
      ]),
      (actionButtons.value.length > 0)
        ? (_openBlock(), _createBlock(ButtonGroup, {
            key: 0,
            "type-list": actionButtons.value,
            onClick: handleClick
          }, null, 8, ["type-list"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_a_modal, {
      class: "modal-dialog",
      visible: rejectedVisible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((rejectedVisible).value = $event)),
      title: 
      dialogType.value == '104' ? '驳回意见' : dialogType.value == '103' ? '通过意见' : ''
    ,
      onOk: setRejectResume,
      onCancel: hiddenReject
    }, {
      default: _withCtx(() => [
        (_unref(type) == '13' && dialogType.value == '103')
          ? (_openBlock(), _createBlock(_component_a_form, {
              key: 0,
              style: {"margin-bottom":"24px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  label: "U8C帐号",
                  required: "",
                  colon: false,
                  rules: []
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      style: {"width":"100%"},
                      value: U8CAccount.value,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((U8CAccount).value = $event)),
                      placeholder: "请填写",
                      maxlength: 50
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_8, [
          (dialogType.value == '104')
            ? (_openBlock(), _createElementBlock("i", _hoisted_9, "*"))
            : _createCommentVNode("", true),
          _hoisted_10
        ]),
        _createVNode(_component_a_textarea, {
          value: rejectResume.value,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((rejectResume).value = $event)),
          placeholder: "请填写",
          maxlength: 1000,
          "auto-size": { minRows: 5, maxRows: 5 }
        }, null, 8, ["value"]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          (uploadTypeValue.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(uploadTypeValue.value ? 'hover-uploader' : '')
              }, [
                (!disableClose.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "close",
                      onClick: resetField
                    }))
                  : _createCommentVNode("", true),
                (getFileType(uploadTypeValue.value) === 1)
                  ? (_openBlock(), _createBlock(_component_a_image, {
                      key: 1,
                      style: {"width":"104px","height":"104px","z-index":"10","padding":"0"},
                      src: uploadTypeValue.value
                    }, null, 8, ["src"]))
                  : (getFileType(uploadTypeValue.value) === 2)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 2,
                        src: require('../../assets/imgs/Common/pdf_1.png'),
                        alt: ""
                      }, null, 8, _hoisted_13))
                    : (getFileType(uploadTypeValue.value) === 3)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 3,
                          src: require('../../assets/imgs/Common/word_1.png'),
                          alt: ""
                        }, null, 8, _hoisted_14))
                      : (getFileType(uploadTypeValue.value) === 5)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 4,
                            src: require('../../assets/imgs/Common/zip_1.png'),
                            alt: ""
                          }, null, 8, _hoisted_15))
                        : (getFileType(uploadTypeValue.value) === 6)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 5,
                              src: require('../../assets/imgs/Common/excel_1.png'),
                              alt: ""
                            }, null, 8, _hoisted_16))
                          : _createCommentVNode("", true)
              ], 2))
            : (_openBlock(), _createBlock(_component_a_upload, {
                key: 1,
                name: "value",
                "list-type": "picture-card",
                class: "avatar-uploader",
                action: `${_unref(axios).defaults.baseURL}api/file/uploadFile`,
                headers: headers,
                "before-upload": beforeUpload,
                onChange: handleChange,
                "show-upload-list": false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    (loading.value)
                      ? (_openBlock(), _createBlock(_unref(LoadingOutlined), { key: 0 }))
                      : (_openBlock(), _createBlock(_unref(PlusOutlined), { key: 1 })),
                    _hoisted_17
                  ])
                ]),
                _: 1
              }, 8, ["action"]))
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(_component_a_modal, {
      visible: showChangeDocking.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((showChangeDocking).value = $event)),
      width: 460,
      bodyStyle: {
      height: '166px',
    },
      title: 
      _unref(form).DockingCashierName == '' && _unref(form).DockingAccountingName == ''
        ? '设置对接集团-出纳、会计'
        : '修改对接集团-出纳、会计'
    ,
      onOk: changeDocking,
      class: "dock-model-wrapper"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          class: "bussiness-form-wrapper",
          validateTrigger: "blur",
          model: _unref(form)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "选择出纳",
              name: "DockingCashier",
              style: {"margin-bottom":"24px"},
              required: "",
              colon: false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _unref(form).DockingCashier,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).DockingCashier) = $event)),
                  "show-search": "",
                  style: {"width":"330px","margin-right":"12px"},
                  placeholder: "请选择或输入",
                  options: allDocking.value,
                  "filter-option": filterOption
                }, null, 8, ["value", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "选择会计",
              required: "",
              name: "DockingAccounting",
              colon: false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _unref(form).DockingAccounting,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).DockingAccounting) = $event)),
                  "show-search": "",
                  style: {"width":"330px","margin-right":"12px"},
                  placeholder: "请选择或输入",
                  options: allAccounting.value,
                  "filter-option": filterOption
                }, null, 8, ["value", "options"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ], 64))
}
}

})